import { NavLink }    from 'react-router-dom';
import AuthService    from 'services/auth.service';

const toggleMobileDropdown = (props) => {
  props.triggerDropdown && props.triggerDropdown();
}

export const ProfileContent = (props) => {
  const currentUser               = AuthService.getCurrentUser();
  const currentAssistant          = AuthService.getCurrentAssistant();
  const location                  = AuthService.getPracticeLocation();

  const logOut = () => {
    AuthService.logout();
    window.location.replace('/eb/login');
  };

  const drName = currentUser?.title ? currentUser?.title + ' ' + currentUser?.name : currentUser?.name;
  // const profileLink = process.env.REACT_APP_PROFILE_URL;

  return(
    <span>
      <span className="d-block px-2 mb-6 font-size-6">You're signed in as <b>{ currentUser?.email }</b>.</span>
      <span className="d-block px-2 mb-2 font-size-6">{ location?.name }</span>

      {
        currentAssistant && currentUser && currentUser.user_type === 'assistant' && (
          <span className="d-block px-2 mb-6 font-size-6">{ currentAssistant?.name } <b className="text-danger">(Assistant)</b></span>
        )
      }

      {
        currentAssistant && currentUser && currentUser.user_type === 'doctor' && (
          <span>
            <span className="d-block px-2 mb-2 font-size-6">{ currentAssistant?.name } <b className="text-danger">(Assistant)</b></span>
            <span className="d-block px-2 mb-6 font-size-6">{ drName } <b className="text-danger">(Doctor)</b></span>
          </span>
        )
      }

      {
        !currentAssistant && currentUser && currentUser.user_type === 'doctor' && (
          <span>
            <span className="d-block px-2 mb-6 font-size-6">{ drName }</span>

            <span className="d-block px-2 mb-2 font-size-7">
              <NavLink end={ true } to="/eb/profile" className="text-white fweight-400" onClick={() => toggleMobileDropdown(props) }>
                My Profile
              </NavLink>
            </span>
          </span>
        )
      }

      <span className="d-block px-2 mb-2 font-size-7">
        <NavLink to="" className="text-white fweight-400" onClick={ logOut }>
          Sign Out
        </NavLink>
      </span>

      <hr className="bg-white mx-2"></hr>

      <div className="d-flex align-items-center">
        <NavLink end={ true } to="/eb/terms" className="text-white px-2" onClick={() => toggleMobileDropdown(props) }>
          Terms of Use
        </NavLink>

        <div className="text-grey mx-1" style={{ borderLeft: '1px solid white' }}>.</div>

        <NavLink end={ true } to="/eb/privacy" className="text-white px-2" onClick={() => toggleMobileDropdown(props) }>
          Privacy Notice
        </NavLink>

        <div className="text-grey mx-1" style={{ borderLeft: '1px solid white' }}>.</div>

        <NavLink end={ true } to="/eb/contact" className="text-white pl-2" onClick={() => toggleMobileDropdown(props) }>
          Contact Us
        </NavLink>
      </div>
    </span>
  );
}